export default __webpack_public_path__ + "static/slider-2-8cfc570c127095dc13c7e2792294ecd0.jpg";